import React from "react";
import { injectIntl } from "react-intl";
import CanvasJSReact from "../../../assets/lib/canvasjs.react";
import "./LineChartStyles.css";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJS.addCultureInfo("jp", {
  saveJPGText: "画像保存（JPEG) ",
  savePNGText: "画像保存（PNG）",
  printText: "印刷",
  menuText:"オプション",
  resetText: "リセット",
  panText: "スクロール"
});

const LineChart = (props: any) => {
  return (
    <div className="chart-container" style={{ width: "100%", height: "100%" }}>
      <div key={props.index}><CanvasJSChart options={props.options}
      /* onRef = {ref => this.chart = ref} */
      /></div>
    </div>
  );
};

export default injectIntl(LineChart);